import { TASK_DECIMAL_SUPPORT } from "../constants/app-common";

export function roundNumberToGivenDecimals(
  numberToRound: number,
  numDecimals: number = TASK_DECIMAL_SUPPORT
) {
  const tenPower = Math.pow(10, numDecimals);
  return Math.round(numberToRound * tenPower) / tenPower;
}

export function generateRandomNumber(
  maxRange: number = 1,
  minRange: number = 0
) {
  return Math.floor(Math.random() * (maxRange - minRange)) + minRange;
}
